import { render, staticRenderFns } from "./ProductCategoryNew.vue?vue&type=template&id=70d573dc&"
import script from "./ProductCategoryNew.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports